module.exports = __webpack_public_path__ + "img/capacity.1eaf39c6.svg";